export default __webpack_public_path__ + "static/media/Apex-Clearing-Logo-683x145-color.e5165098.svg";